import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import ReactDomClient from 'react-dom/client'
import useNotification from '../../../baseComponent/notification'
import Button from '../../../baseComponent/button'
import request from '../../../utils/request'
import globalData from '../../../common/globalData'
import Icon from '../../icon'
import styles from './index.module.less'

const CollectNotification = ({ onDestroy }) => {
  const [api] = useNotification({
    duration: 0,
  }, onDestroy)

  useEffect(() => {
    fetchCollectNum()
    fetchRankIng()
  }, [])

  const fetchCollectNum = async () => {
    const result = await request.get('/zhikuan/mn/propagate/get-user-collect-times')
    const collectNumbers = [1, 100, 500, 1000, 2000, 3000] // 当完成这些目标采集数量则弹出
    if (collectNumbers.includes(result)) {
      api.open({
        content: notificationUnlock(result),
      })
    }
  }

  const fetchRankIng = async () => {
    const result = await request.get('/zhikuan/mn/propagate/blog-this-week-collect')
    const rank = await globalData.toGetObj('mn-collect-num-rank') || {}
    if (result.afterWednesday) { // 周三之后
      // 当存在之前的记录 则代表已经谈过第一次 则之前的记录不能为第一名 且新记录为第一名的时候作为第一名弹出
      if (rank?.oldValue && rank?.oldValue !== 1 && result.ranking === 1) {
        api.open({
          content: notificationRanking(result),
        })
      } else if (!rank?.oldValue && result.ranking === 1) { // 没有之前的记录 则代表是第一次弹出排名 并且排名是第一名
        api.open({
          content: notificationRanking(result),
        })
      }
      globalData.toSetObj('mn-collect-num-rank', {
        oldValue: rank.newValue || result.ranking,
        newValue: result.ranking,
      })
    }
  }

  const notificationRanking = (result = {}) => (<div
    className={styles.mnNotificationRanking}
  >
    <div className="notificationRankingHeaderInfo">
      <img className="notificationRankingHeaderInfoImage" src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/collect-notification/ranking.png" />
      <div>
        <div className="notificationRankingHeaderInfoTitle">本周采集数在团队中排名NO.{result.ranking}</div>
        <div className="notificationRankingHeaderInfoText">本周您已采集了{result.blogNum}个款式</div>
      </div>
    </div>
    <Button
      type="primary"
      className="notificationRankingLink"
      onClick={() => {
        window.open('/meinian/home')
      }}
    >打开美念，查看采集<Icon type="m-jiantou_you" className="notificationRankingLinkIcon" /></Button>
  </div>)

  const notificationUnlock = (num) => (<div
    className={styles.mnNotificationUnlock}
  >
    <div className="mnNotificationUnlockHeader">
      <img className="mnNotificationUnlockImage" src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/collect-notification/ranking.png" />
    </div>
    <div className="mnNotificationUnlockTitle">
      完成第{num}次采集，恭喜解锁新功能“美念”
    </div>
    <div className="mnNotificationUnlockInfo">
      <div className="mnNotificationUnlockInfoItem"><div className="mnNotificationUnlockInfoPoint" />批量下载、导出图片</div>
      <div className="mnNotificationUnlockInfoItem"><div className="mnNotificationUnlockInfoPoint" />智能识别服饰标签，自动分门别类</div>
      <div className="mnNotificationUnlockInfoItem"><div className="mnNotificationUnlockInfoPoint" />保留原链接，支持快速访问</div>
    </div>
    <div className="mnNotificationUnlockInfo2">
      用美念,选择高效的工作方式
    </div>
    <Button
      type="primary"
      className="mnNotificationUnlockLink"
      onClick={() => {
        window.open('/meinian/home')
      }}
    >去管理采集图片<Icon type="m-jiantou_you" className="mnNotificationUnlockLinkIcon" /></Button>
  </div>)
  return <div />
}

export default (props) => {
  const div = document.createElement('div')
  let root = null
  const onDestroy = (resolve, val) => {
    if (ReactDOM?.unmountComponentAtNode) {
      const unmountResult = ReactDOM?.unmountComponentAtNode(div)
      if (unmountResult && div.parentNode) {
        div.parentNode?.removeChild(div)
        resolve(val)
      }
    }
    if (root) {
      root.unmount()
    }
  }
  return new Promise(() => {
    if (ReactDOM?.render) {
      ReactDOM?.render(<CollectNotification {...props} container={div} onDestroy={onDestroy} />, div)
    } else if (ReactDomClient.createRoot) {
      root = ReactDomClient.createRoot(div)
      root.render(<CollectNotification {...props} container={div} onDestroy={onDestroy} />)
    }
  })
}
